import { render, staticRenderFns } from "./icon-backgrounds.vue?vue&type=template&id=605e2df0"
import script from "./icon-backgrounds.vue?vue&type=script&lang=js"
export * from "./icon-backgrounds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports